import styled from "styled-components";

const StyledTransformeContainer = styled.div`
  &.TransformerContainer {
    box-shadow: ${(props) =>
      props.$subtle
        ? "0 12px 32px rgba(36, 123, 160, 0.12), 0 1px 4px rgba(0, 0, 0, 0.06)"
        : "0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)"};
    margin-bottom: 30px;
    border-radius: ${(props) => props.theme.roundedRadius};
    background-color: ${(props) => props.theme.lightColor};
    padding: ${(props) => (props.padding ? "30px" : "0")};

    @media only screen and (max-width: 720px) {
      max-width: 100%;
      margin: 0 auto;
      border-radius: 0px;
      box-shadow: none;
    }
  }
`;

const TransformerContainer = (props) => {
  return (
    <StyledTransformeContainer className="TransformerContainer" {...props}>
      {props.children}
    </StyledTransformeContainer>
  );
};

export default TransformerContainer;
